import { C, HEADSHOT } from "../../data/content";
import { RegFormV2 } from "./RegFormV2";
import { Countdown, DATE_LABEL } from "./Countdown";

export const HeroV2 = ({ attribution }) => (
  <section id="register" className="pt-28 md:pt-32 pb-16 px-4 lg:px-6 bg-gradient-to-b from-white to-[#F9FAFB] scroll-mt-16" data-testid="hero-v2">
    <div className="max-w-[1200px] mx-auto grid lg:grid-cols-[1.1fr_0.9fr] gap-10 lg:gap-14 items-start">
      <div>
        <p className="inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.18em] text-[#444CE7] bg-[#444CE7]/[0.07] border border-[#444CE7]/20 rounded-full px-4 py-2 mb-6" data-testid="hero-eyebrow-v2">
          <span className="w-1.5 h-1.5 rounded-full bg-[#444CE7] animate-pulse" />
          FREE LIVE WEBINAR — VA-ELIGIBLE BUYERS · FL, TX & PA
        </p>
        <h1 className="text-[clamp(34px,4.6vw,58px)] font-black text-[#101828] leading-[1.05] tracking-[-0.02em] mb-5" data-testid="hero-h1-v2">
          Your VA Benefit Is Bigger Than You Think.<br />
          <span className="text-[#444CE7]">Learn How To Use It — Live.</span>
        </h1>
        <p className="text-[17px] text-[#475467] leading-relaxed max-w-[540px] mb-6" data-testid="hero-sub-v2">
          Join the free <strong className="text-[#1D2939]">Veteran Fast-Track Review</strong> webinar and learn how VA-eligible buyers go from "not sure I qualify" to a confident offer — without a hard credit pull, in about 60 minutes.
        </p>
        <div className="flex flex-wrap items-center gap-4 mb-8">
          <div className="text-[14px] font-bold text-[#1D2939]" data-testid="hero-date-v2">📅 Two live sessions: {DATE_LABEL}</div>
        </div>
        <div className="mb-8"><Countdown light /></div>

        <div className="lg:hidden mb-8"><RegFormV2 attribution={attribution} tid="reg-m" /></div>

        <div className="rounded-2xl overflow-hidden border border-[#EAECF0] bg-[#101828] aspect-video relative" data-testid="hero-video-placeholder">
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
            <div className="w-16 h-16 rounded-full bg-[#444CE7] flex items-center justify-center shadow-[0_0_40px_rgba(68,76,231,0.5)]">
              <span className="text-white text-xl ml-1">▶</span>
            </div>
            <p className="text-white/50 text-[11px] font-mono tracking-[0.2em]">[ VIDEO PLACEHOLDER — ADD WEBINAR INTRO VIDEO URL ]</p>
          </div>
        </div>

        <div className="flex items-center gap-3 mt-8">
          <img src={HEADSHOT} alt="Darren Gussick" className="w-12 h-12 rounded-full object-cover border-2 border-[#444CE7]" />
          <div>
            <p className="text-[14px] font-bold text-[#1D2939]">Hosted by {C.hostName}</p>
            <p className="text-[12px] text-[#98A2B3]">{C.hostCompany} · NMLS #{C.hostNmls} · 25 years in mortgage</p>
          </div>
        </div>
      </div>
      <div className="hidden lg:block lg:sticky lg:top-24">
        <RegFormV2 attribution={attribution} />
      </div>
    </div>
  </section>
);
